import React from "react";
import "./GitHubLink.css";

export default function GitHubLink() {
  return (
    <p>
      <a
        href="https://github.com/scmendez/weather-app-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open-source code
      </a>{" "}
      by Sandra Mendez.
    </p>
  );
}
